import * as Yup from 'yup';
import { FILING_STATUS, CURRENT_AGE, SPOUSE_CURRENT_AGE } from '../../../constants';

const SecondStepSchemaValidator = () => Yup.object().shape({
  benefitEstimator: Yup.object().shape({
    spouseCurrentAge: Yup.number()
      .when('filingStatus', {
        is: (filingStatus) => filingStatus === FILING_STATUS.JOINT,
        then: () => Yup.number()
          .min(SPOUSE_CURRENT_AGE.MIN, `Select a spouse age from ${CURRENT_AGE.MIN} to ${CURRENT_AGE.MAX} years old`)
          .max(SPOUSE_CURRENT_AGE.MAX, `Select a spouse age from ${CURRENT_AGE.MIN} to ${CURRENT_AGE.MAX} years old`)
          .required('This field is required'),
      }),
    currentAge: Yup.number()
      .required('This field is required')
      .max(CURRENT_AGE.MAX, `Select an age from ${CURRENT_AGE.MIN} to ${CURRENT_AGE.MAX} years old`)
      .min(CURRENT_AGE.MIN, `Select an age from ${CURRENT_AGE.MIN} to ${CURRENT_AGE.MAX} years old`),
  }),
});

export default SecondStepSchemaValidator;
